import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery, useQueryClient, useMutation} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post, del } from "@utils/axios_api";
import { qk } from "@utils/queryKey";
import { downloadExcel } from "@utils/downloadExcel";

const fetchLectureInvoiceList = async (params) => {
  const response = await get("/admin/lectureInvoice/invoiceList", { params });
  return response;
};


export function useLectureInvoice(lectureId) {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();
  
  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      sourceType: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const sourceType = searchParams.get("sourceType") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd, searchWrd, lectureId, sourceType,
    pageIndex, recordCountPerPage,
  };

  const { data, refetch } = useQuery({
    queryKey: [...qk.invoiceList(lectureId), JSON.stringify(queryParam)],
    queryFn: () => fetchLectureInvoiceList(queryParam),
    keepPreviousData: true,
    enabled: !!lectureId
  });



  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("sourceType", values.sourceType || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    methods.reset({
      searchCnd: "",
      searchWrd: "",
      sourceType: "",
    });
    setSearchParams(new URLSearchParams());
  };

  const delMut = useMutation(
    (id) => post('/admin/lectureInvoice/updateInvoiceUseYn', {invoiceId: id }),
    {
      onSuccess: (res) => {
        alert(res.message);
        refetch();
      },
      onError: () => alert('삭제 실패'),
    }
  );

  const handleDelete = (invoiceId) => {
  if (!window.confirm('정말 삭제하시겠습니까?')) return;
    delMut.mutate(invoiceId);
  };

  const handleExcelDownload = (e) => {
    e.preventDefault();
    downloadExcel({
      url: "/admin/lectureInvoice/invoiceListExcelDown",
      params: queryParam,
      filePrefix: "교육세금계산서",
    });

  }


  return {
    methods, data,
    onSubmit,
    handlePageChange, handleDelete, handleExcelDownload, resetSearch,
    pageIndex, recordCountPerPage,
    refetch, refreshList,
  };
}
